<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <template>
            <div id="user-edit-tab-info">
              <vs-alert
                v-if="operation_data.pending_admin_validation"
                color="warning"
                icon-pack="feather"
                icon="icon-clock"
                :active="true"
                class="mb-4">
                This quotation was approved by a broker and is awaiting your validation. Validate it from the main dashboard.
              </vs-alert>
              <!-- Content Row -->
              <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full">
                  <vx-input-group class="mt-4">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>Reference XYLO No. #</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.id" disabled size="default" />
                  </vx-input-group>
                  <vx-input-group class="mt-4">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>Reference Client&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.ref_client" size="default" />
                  </vx-input-group>

                  <!--<p class="w-full mt-4" style="font-size: 85%">
                    &nbsp;Type of Quotation
                    <vs-switch
                      color="dark"
                      icon-pack="feather"
                      vs-icon-off="icon-git-commit"
                      vs-icon-on="icon-user"
                      v-model="operation_data.isquotationparent"
                    >
                      <span slot="on">Parent</span>
                      <span slot="off">Normal</span>
                    </vs-switch>
                  </p>-->

                  <p class="w-full mt-2" style="font-size: 85%">
                    &nbsp;Operation Date
                    <datepicker :inline="false" v-model="operation_data.date"></datepicker>
                  </p>
                  <p class="w-full mt-2" style="font-size: 85%">
                    &nbsp;Date of Delivery (Expected by the customer)
                    <datepicker :inline="false" v-model="operation_data.date_delivery_desired"></datepicker>
                  </p>
                  <!-- Repris tel quel dans l'accusé de réception de commande
                       (ligne « Livraison prévue », masquée si vide). -->
                  <div class="w-full mt-2" style="font-size: 85%">
                    &nbsp;Confirmed delivery (order acknowledgment)
                    <vs-input v-model="operation_data.delivery_lead_time" class="w-full"
                      placeholder="e.g. week 44 / semaine 44 — empty = line hidden" />
                  </div>
                  <div class="w-full mt-2">
                    <div style="font-size: 85%">Quotation Status</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select :options="data_option_quotation_status" v-model="statusId" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-row mt-2">
                    <div class="vx-col w-1/2">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Quotation Tag</div>
                        <v-select class="w-full" style="background-color: #ffffff" autocomplete
                          :options="select_quotation_tag" v-model="quotation_tag" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-row mt-2">
                    <div class="vx-col w-1/2">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Transport Type</div>
                        <v-select class="w-full" style="background-color: #ffffff" autocomplete
                          :options="select_transport_type" v-model="transporttip" />
                      </div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Trailer Type</div>
                        <v-select style="background-color: #ffffff" class="w-full" autocomplete
                          :options="select_trailer_type" v-model="remorcatip" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-row mt-2">
                    <div class="vx-col w-full">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Sumal Mode</div>
                        <v-select class="w-full" style="background-color: #ffffff" autocomplete
                          :options="select_sumal_override" v-model="sumaltip" />
                      </div>
                    </div>
                  </div>
                  <div class="w-full  mt-4" >
                    <div class="vx-col md:w-12/12 w-full">
                      <span class="w-full" style="font-size:85%">
                        &nbsp;FSC Required?
                        <vs-switch class="w-full mt-0" color="success" icon-pack="feather" vs-icon-on="icon-yes"
                          vs-icon-off="icon-no" v-model="operation_data.fsc">
                          <span slot="on">YES</span>
                          <span slot="off">NO</span>
                        </vs-switch>
                        <small class="block mt-1" style="color:#8a8a8a">
                          When on, the FSC product group (Anexa 4: W 5.5 Poles, W 5.4 Planks, W13.4 Fences…) is
                          printed after each product name on the quotation and invoice PDFs, and the sale counts
                          in STOCK → FSC. Groups are set per category on that page.
                        </small>
                      </span>
                    </div>
                  </div>
                  <div class="w-full  mt-4" >
                    <div class="vx-col md:w-12/12 w-full">
                      <span class="w-full" style="font-size:85%">
                        &nbsp;Call client before arrival
                        <vs-switch class="w-full mt-0" color="success" icon-pack="feather" vs-icon-on="icon-phone"
                          vs-icon-off="icon-phone" v-model="operation_data.callclient">
                          <span slot="on">YES</span>
                          <span slot="off">NO</span>
                        </vs-switch>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <div class="w-full mt-0">
                    <div class="w-full mt-0">
                      <div style="font-size: 85%">Potential Client</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select autocomplete :options="data_option_people_name" v-model="personId"
                            @input="getBillingAndDeliveryAddressList(true)" />
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-2">
                      <div style="font-size: 85%">
                        Billing Address
                        <span v-if="addressesLoading" class="text-warning ml-2" style="font-size: 90%">(loading...)</span>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select autocomplete :disabled="addressesLoading" :options="data_option_billing_address" v-model="billingAddressId" />
                          <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                               choisir une adresse quelconque du client a sa place. -->
                          <span v-if="billingAddressUnlinked" class="text-warning text-sm">No billing address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-2">
                      <div style="font-size: 85%">
                        Delivery Address
                        <span v-if="addressesLoading" class="text-warning ml-2" style="font-size: 90%">(loading...)</span>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select autocomplete :disabled="addressesLoading" :options="data_option_delivery_address" v-model="deliveryAddressId" />
                          <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                               choisir une adresse quelconque du client a sa place. -->
                          <span v-if="deliveryAddressUnlinked" class="text-warning text-sm">No delivery address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                        </div>
                      </div>
                    </div>

                    <div class="vx-row mt-8">
                      <div class="vx-col w-full">
                        <span class="w-full" style="font-size:85%">
                          Broker
                        <v-select disabled autocomplete :options="data_option_broker_name" v-model="brokerId" :reduce="option => option.value" label="label" />
                        </span>
                      </div>
                   </div>

                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <div class="vx-col md:w-full">
                    <div class="vx-row">
                      <div class="vx-col w-1/3 mt-0">
                        <div style="font-size: 85%">Advance Payment (%)</div>
                        <vs-input v-validate="'required|decimal'" v-model="dataAdvancePct" class="w-full"
                          name="Advance Payment %" @input="calculateAdvanceFromPctInput()" />
                        <span v-show="errors.has('Advance Payment %')" class="text-danger">{{ errors.first("Advance Payment % ") }}</span>
                      </div>
                      <div class="vx-col w-2/3 mt-0">
                        <div></div>
                        <vs-alert v-if="dataAdvancePct == 100" color="warning" title="Information" active="true">Payment
                          upon order.</vs-alert>
                        <vs-alert v-else-if="dataAdvancePct == 0" color="danger" title="Information" active="true">Payment
                          upon delivery.</vs-alert>
                        <vs-alert v-else color="primary" title="Information" active="true">Advance of {{ dataAdvancePct
                        }}% and balance on
                          delivery.</vs-alert>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-full mt-2">
                    <div style="font-size: 85%">Incoterms</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select :options="incotermOptions" v-model="IncotermId" @input="onIncotermInput" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-full mt-2" v-if="IncotermId.value == 'CPT - Carriage Paid To'">
                    <div style="font-size: 85%">Incoterms Clause Location</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <vs-input v-model="dataIncotermsDest" class="w-full"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-full mt-2">
                    <div class="vx-row">
                      <div class="vx-col w-1/3 mt-0">
                        <div style="font-size: 85%">VAT (%)</div>
                        <vs-input v-validate="'required|decimal'" v-model="dataTva" class="w-full" name="tva" />
                        <span v-show="errors.has('tva')" class="text-danger">{{
                          errors.first("tva")
                        }}</span>
                        <vs-button class="mt-2" size="small" type="border" icon-pack="feather" icon="icon-refresh-cw"
                          @click="recomputeTva">Recalculate VAT</vs-button>
                      </div>
                      <div class="vx-col w-2/3 mt-0">
                        <div></div>
                        <vs-alert v-if="dataTva == '0'" color="warning" title="Warning" active="true">Exempt from
                          VAT.</vs-alert>
                        <vs-alert v-else color="primary" title="Information" active="true">Applicable VAT of {{ dataTva
                        }}%.</vs-alert>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full mt-4">
                  <div class="w-full mt-0">

                    <div style="font-size: 85%">Internal Note</div>
                    <VueEditor class="w-full" v-model="operation_data.mail_top" :editor-toolbar="customToolbar" />
                    <!-- <vs-textarea
                      class="w-full mt-4 h-64"
                      counter="600"
                      label="Internal Note"
                      :counter-danger.sync="counterDanger"
                      v-model="operation_data.mail_top"
                    />-->
                  </div>
                </div>
              </div>
              <template>
                <div id="data-list-list-view" class="data-list-container mt-16">
                  <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
                    :data="sidebarData" />

                  <vs-table ref="table" :data="products">
                    <div slot="header" class="
                        flex flex-wrap-reverse
                        items-center
                        flex-grow
                        justify-between
                      ">
                      <div class="
                          flex flex-wrap-reverse
                          items-center
                          data-list-btn-container
                        ">
                        <!-- ACTION - DROPDOWN -->

                        <!-- ADD NEW -->
                        <div class="
                            btn-add-new
                            p-3
                            mb-4
                            mr-4
                            rounded-lg
                            cursor-pointer
                            flex
                            items-center
                            justify-center
                            text-lg
                            font-medium
                            text-base text-primary
                            border border-solid border-primary
                          " @click="addNewData">
                          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                          <span class="ml-2 text-base text-primary">Add Product</span>
                        </div>
                      </div>
                    </div>

                    <template slot="thead">
                      <vs-th>#</vs-th>
                      <vs-th>Category Product</vs-th>
                      <vs-th>Name</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th>Unit Price (EUR/UoM)</vs-th>
                      <vs-th>Unit of Measure</vs-th>
                      <vs-th>Volume Unit (m3/UoM)</vs-th>
                      <vs-th>Volume Total (m3)</vs-th>
                      <vs-th>Price per m3 (EUR/m3)</vs-th>
                      <vs-th>Total Price (EUR)</vs-th>
                      <vs-th>Priority?</vs-th>
                      <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                            <p class="font-medium truncate">
                              {{ indextr + 1 }}
                            </p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">
                              {{ tr.productcategory.name_en }}
                            </p>
                          </vs-td>

                          <vs-td>
                            <p>{{ tr.name_en }}</p>
                          </vs-td>

                          <vs-td>
                            <p>
                              {{
                                Math.abs(
                                  tr.operations_products.quantity
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>

                          <vs-td>
                            <p>
                              {{
                                parseFloat(
                                  tr.operations_products.unit_price
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>

                          <vs-td>{{ tr.uomsreference.name_en }}</vs-td>

                          <vs-td>
                            <p v-if="tr.volume">
                              {{ Math.abs(tr.volume).toFixed(4) }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.volume">
                              {{
                                Math.abs(
                                  tr.volume * tr.operations_products.quantity
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.volume">
                              {{
                                Math.abs(
                                  (tr.operations_products.quantity *
                                    tr.operations_products.unit_price) /
                                  (tr.volume *
                                    tr.operations_products.quantity)
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p>
                              {{
                                parseFloat(
                                  Math.abs(tr.operations_products.quantity) *
                                  tr.operations_products.unit_price
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p :style="{ color: tr.operations_products.isprior ? 'red' : 'inherit' }">
                              {{ tr.operations_products.isprior ? 'Priority' : 'Normal' }}
                            </p>
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click.stop="editData(tr)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2" @click.stop="deleteProduct(tr.id, tr.name_en)" />
                          </vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                </div>

                <div class="vx-row">
                  <div class="vx-col md:w-full">
                    <div class="w-full mt-16 md:w-full">
                      <div style="font-size: 75%">Bottom Mail Template</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select :options="data_option_bottom_mail_template" v-model="bottomMailTemplateId"
                            @input="writeBottomMailTemplate()" />
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-0 md:w-full">
                      <vs-textarea style="height: auto" rows="10" class="w-full mt-10" label="Bottom mail"
                        v-model="operation_data.mail_bottom" />
                    </div>
                    * Additional details: <br />
                    - The link with the photos;<br />
                    - If the service groupage is on the quotation, the link
                    about groupage;<br />
                    - The incoterms. <br /><br />* Payment information: <br />
                    - If there is a VAT exemption;<br />
                    - If there is an advance payment or payment upon order.
                    <br /><br />
                  </div>
                  <!--
                  <div class="vx-col md:w-1/2 w-full mt-10">
                    <vs-textarea
                      style="height: auto"
                      rows="10"
                      class="w-full mt-10"
                      label="Bottom mail payment"
                      v-model="operation_data.mail_bottom_payment"
                    />
                  * Additional bottom mail payment information: <br/>   - If there is a VAT exemption;<br/>   - If there is an advance payment.
                  </div>  -->
                </div>
              </template>
              <!-- Save & Reset Button -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-4 flex flex-wrap items-center justify-end">
                    <vs-button v-if="operation_data.isactive && displayExport != false" type="border" color="danger"
                      icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Disable</vs-button>
                    <vs-button v-else type="border" color="success" icon-pack="feather" icon="icon-trash"
                      @click="confirmEnableRecord">Enable</vs-button>&nbsp;&nbsp;
                    <!--<vs-button
                      type="border"
                      color="warning"
                      icon-pack="feather"
                      icon="icon-cpu"
                      @click="confirmTransformToSale"
                      >Transform to Sale</vs-button
                    >-->
                    <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm || addressesLoading">Save
                      Changes</vs-button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import addressSelection from "@/mixins/addressSelection";
import pricingZones from "@/mixins/pricingZones";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { hasFirewoodLine } from "@/helpers/firewood";

export default {
  mixins: [pricingZones, addressSelection],
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker,
    VueEditor
  },
  data() {
    return {
      dataIncotermsDest: null,
      // L'utilisateur a choisi l'incoterm lui-même : le défaut bois de chauffage
      // (FCA Teiu) ne doit plus le toucher.
      incotermTouched: false,
      // Dernière vente de bois du client, pour l'incoterm par défaut.
      firewoodIncotermHistory: null,
      customToolbar: [
        ["bold", "italic"],
        [{ color: [] }]
      ],
      remorcatip: null,
      transporttip: null,
      quotation_tag:null,
      sumaltip:'Auto',
      select_transport_type: [
        { label: "Rutier", value: "Rutier" },
        { label: "Intermodal", value: "Intermodal" },
      ],
      select_sumal_override: [
        { label: "Auto", value: "auto" },
        { label: "Force Mandatory", value: "forcetrue" },
        { label: "Force NOT Mandatory", value: "forcefalse" },
      ],
      select_trailer_type: [
        { label: "tautliner", value: "tautliner" },
        { label: "MEGA", value: "MEGA" },
      ],
      select_quotation_tag: [
        { label: "A (Good)", value: "A" },
        { label: "B (Medium)", value: "B" },
        { label: "C (Low)", value: "C" },
        { label: "NULL", value: null },
      ],
      quotation_tag: null,
      displayExport: false,
      operation_data: null,
      product_data: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      producttodelete: null,
      statusId: null,
      data_option_quotation_status: [],
      dataTva: null,
      // Vrai dès qu'une TVA est déjà enregistrée sur le devis : le calcul
      // automatique ne doit alors plus rien écraser (seul le bouton
      // « Recalculer la TVA » le peut, sur action explicite de l'utilisateur).
      storedTvaLocked: false,
      data_option_billing_address: [],
      data_option_delivery_address: [],
      databroker: [],
      billingAddressId: null,
      deliveryAddressId: null,
      mail_bottom: null,
      data_option_bottom_mail_template: [
        {
          value: 1,
          label: "Devis Round Stakes English",
        },
        {
          value: 2,
          label: "Devis Round Stakes Français",
        },
        {
          value: 3,
          label: "Devis Round Stakes Română",
        },
        {
          value: 4,
          label: "Devis Round Stakes Deutsche",
        },
        {
          value: 5,
          label: "Devis Round Stakes Español",
        },
        {
          value: 6,
          label: "Devis Round Stakes Nederlands",
        },
      ],
      bottomMailTemplateId: null,
      IncotermId: {
        value: "DAP - Delivered at Place",
        label: "DAP - Delivered at Place",
      },
      dataAdvanceEur: 0,
      dataAdvancePct: 0,
      selectedVatNumber: null,
      selectedLanguage: null,
      data_option_broker_name: [],
      brokerId: null,
    };
  },
  computed: {
    products() {
      return this.$store.state.operationList.operationproducts;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    // Sélectionne l'incoterm enregistré sur l'opération. Une valeur absente de la liste
    // (libellé de zone dynamique "DAP BENELUX", ancien "EXW"…) est CONSERVÉE telle quelle :
    // avant, elle tombait dans un else qui la réécrivait silencieusement en
    // "CPT - Carriage Paid To" dès le premier enregistrement.
    applyStoredIncoterm() {
      const stored = (this.operation_data && this.operation_data.incoterms)
        ? String(this.operation_data.incoterms).trim()
        : "";
      this.dataIncotermsDest = this.operation_data ? this.operation_data.incoterms_dest : null;
      if (!stored) {
        this.IncotermId = { value: "DAP - Delivered at Place", label: "DAP - Delivered at Place" };
        return;
      }
      const known = (this.incotermOptions || []).filter((o) => o.value === stored)[0];
      if (known) {
        this.IncotermId = known;
        return;
      }
      // Anciennes écritures non canoniques : on recale sur l'option équivalente.
      if (stored.includes("Free")) {
        this.IncotermId = { value: "FCA - Free Carrier", label: "FCA - Free Carrier" };
      } else if (stored.includes("Carriage")) {
        this.IncotermId = { value: "CPT - Carriage Paid To", label: "CPT - Carriage Paid To" };
      } else if (stored.includes("Delivered at Place")) {
        this.IncotermId = { value: "DAP - Delivered at Place", label: "DAP - Delivered at Place" };
      } else {
        this.IncotermId = { value: stored, label: stored };
      }
    },
    // Taux de TVA enregistré sur le devis : première ligne dont tva_pct est
    // renseigné. On ne se contente pas de products[0], qui peut être une ligne
    // ajoutée après coup et laissée à NULL.
    readStoredTva() {
      const products =
        (this.operation_data && this.operation_data.products) || [];
      for (const product of products) {
        const raw = product.operations_products
          ? product.operations_products.tva_pct
          : null;
        if (raw === null || raw === undefined || raw === "") continue;
        if (!Number.isFinite(Number(raw))) continue;
        return raw;
      }
      return null;
    },
    // Choix explicite de l'utilisateur dans le sélecteur Incoterms.
    onIncotermInput() {
      this.incotermTouched = true;
    },
    // Bois de chauffage en Roumanie (Ferdinand, 2026-10-09) : « FCA Teiu » par
    // défaut (option à part entière). Seulement pour un devis dont l'incoterm
    // n'a jamais été enregistré, tant que l'utilisateur n'a pas touché le
    // sélecteur et que le défaut DAP est encore en place : un choix explicite
    // ou un devis existant ne sont jamais écrasés. Un client LIVRÉ (dernière
    // vente de bois en DAP, ex. Teodora Industry, Chady 2026-10-12) garde DAP.
    async applyFirewoodIncotermDefault(productId = null) {
      if (!this.firewoodIncotermDefaultApplies(productId)) return;
      const history = await this.fetchFirewoodIncotermHistory();
      // Re-vérifié après l'appel : l'utilisateur a pu choisir entre-temps.
      if (!this.firewoodIncotermDefaultApplies(productId)) return;
      if (history && history.incoterms && history.departure === false) return;
      this.IncotermId = { value: "FCA Teiu", label: "FCA Teiu" };
    },
    // Dernière vente de bois de chauffage du client (API, mise en cache par client) :
    // un client livré (DAP, ex. Teodora Industry) garde son terme, pas FCA Teiu.
    async fetchFirewoodIncotermHistory() {
      const person =
        (this.personId && this.personId.value) ||
        (this.operation_data && this.operation_data.people && this.operation_data.people[0] && this.operation_data.people[0].id);
      if (!person) return null;
      if (this.firewoodIncotermHistory && this.firewoodIncotermHistory.person === person) {
        return this.firewoodIncotermHistory.data;
      }
      try {
        const r = await axios.get("/person/lastfirewoodincoterm/" + person, {
          params: { exclude: this.operation_data && this.operation_data.id },
        });
        this.firewoodIncotermHistory = { person, data: r.data };
        return r.data;
      } catch (e) {
        return null;
      }
    },
    firewoodIncotermDefaultApplies(productId = null) {
      if (this.operation_data && this.operation_data.incoterms) return false;
      if (this.incotermTouched) return false;
      if (!this.IncotermId || this.IncotermId.value !== "DAP - Delivered at Place") return false;
      const lines = (this.operation_data && this.operation_data.products) || [];
      if (!hasFirewoodLine(lines, productId)) return false;
      let isRomania = false;
      if (this.billingAddressId && this.billingAddressId.label) {
        isRomania = this.billingAddressId.label.includes("Romania");
      } else if (this.data_option_billing_address && this.data_option_billing_address.length > 0) {
        const firstAddress = this.data_option_billing_address[0];
        isRomania = !!(firstAddress.label && firstAddress.label.includes("Romania"));
      }
      return isRomania;
    },
    // Applique la règle pays / bois de chauffage / exonération.
    // force = true uniquement depuis le bouton « Recalculer la TVA » : le taux
    // enregistré fait foi et n'est jamais réécrit automatiquement à l'édition.
    updateTvaForFirewood(productId = null, { force = false } = {}) {
      // Même déclencheurs que la TVA (chargement, adresse, ligne ajoutée) :
      // l'incoterm par défaut du bois de chauffage se décide ici, AVANT le
      // verrou TVA qui ne le concerne pas.
      this.applyFirewoodIncotermDefault(productId);
      if (this.storedTvaLocked && !force) {
        return;
      }

      // Le document est « bois de chauffage » dès qu'UNE de ses lignes l'est.
      // On ne regarde plus products[0] : trié par id, une ligne Transport (1) ou
      // Advance (1692) y passait devant le bois et imposait 21 % à la facture.
      const lines = (this.operation_data && this.operation_data.products) || [];
      const isFirewood = hasFirewoodLine(lines, productId);
      const hasLines = lines.length > 0 || (productId !== null && productId !== undefined);
      
      // Vérifier si le client est en Roumanie
      let isRomania = false;
      if (this.billingAddressId && this.billingAddressId.label) {
        isRomania = this.billingAddressId.label.includes("Romania");
      } else if (this.data_option_billing_address && this.data_option_billing_address.length > 0) {
        const firstAddress = this.data_option_billing_address[0];
        if (firstAddress.label) {
          isRomania = firstAddress.label.includes("Romania");
        }
      }
      
      // Roumanie : si client a TVA valide (RO) → 0%, sinon 11% (bois) ou 21%.
      // Même règle que l'écran facture, pour que devis et facture ne divergent pas.
      if (isRomania && hasLines) {
        const person = this.operation_data && this.operation_data.people && this.operation_data.people[0];
        const hasValidRoVat = person && person.subject_vat && person.vat_number && String(person.vat_number).replace(/\s/g, "").toUpperCase().startsWith("RO");
        if (hasValidRoVat) {
          this.dataTva = "0";
        } else if (isFirewood) {
          this.dataTva = "11";
        } else {
          this.dataTva = "21";
        }
      }
    },
    // Seul chemin qui écrase une TVA enregistrée, et il est déclenché à la main.
    recomputeTva() {
      const before = this.dataTva;
      this.updateTvaForFirewood(null, { force: true });
      if (String(this.dataTva) === String(before)) {
        this.$vs.notify({
          color: "primary",
          title: "VAT unchanged",
          text: "The applicable rule still gives " + before + "%.",
        });
      } else {
        this.$vs.notify({
          color: "warning",
          title: "VAT recalculated",
          text: before + "% → " + this.dataTva + "%",
        });
      }
    },
    getBottomMailTemplate() {
      // Le garde testait this.mail_bottom (donnee de composant jamais alimentee),
      // pas le champ du document : il etait donc toujours vrai.
      if (
        this.operation_data.mail_bottom != null &&
        this.operation_data.mail_bottom !== ""
      )
        return;
      const ItemIndex = this.data_option_bottom_mail_template.findIndex(
        (p) => p.value === this.selectedLanguage
      );
      // Langue inconnue : findIndex renvoie -1, d'ou un bottomMailTemplateId
      // undefined sur lequel writeBottomMailTemplate() plantait.
      if (ItemIndex === -1) return;
      this.bottomMailTemplateId =
        this.data_option_bottom_mail_template[ItemIndex];
      this.writeBottomMailTemplate();
    },
    calculateAdvanceFromPctInput() {
      //if (this.m3difference)
      {
        this.$store
          .dispatch(
            "operationList/fetcheurdifference",
            this.$route.params.userId
          )
          .then((res) => {
            this.m3difference = res;
            /*this.dataAdvanceEur =
              (this.m3difference / 100) * this.dataAdvancePct;*/
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    calculateAdvanceFromEurInput() {
      //if (this.m3difference)
      {
        this.$store
          .dispatch(
            "operationList/fetcheurdifference",
            this.$route.params.userId
          )
          .then((res) => {
            this.m3difference = res;
            /*this.dataAdvancePct =
              (this.dataAdvanceEur / this.m3difference) * 100;*/
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    writeBottomMailTemplate() {
      if (this.bottomMailTemplateId.value === 1) {
        // EN
        this.operation_data.mail_bottom =
          "   - Wood species: Robinia Pseudoacacia.\n   - Diameter measured in the middle.\n   - The Customer takes care of unloading the truck (a truck of 40 tons) and verifying the accessibility of the delivery address.\n   - Delivery time: 2-6 weeks (for groupage, it may take a little longer).";
        this.operation_data.mail_bottom_payment =
          "Payment:\n   - Payment upon order.";
      } else if (this.bottomMailTemplateId.value === 2) {
        // FR
        this.operation_data.mail_bottom =
          "   - Essence de bois: Robinia Pseudoacacia.\n   - Diamètre mesuré au milieu.\n   - Le Client s'occupe du déchargement du camion (semi-remorque de 40 tonnes) et de vérifier l'accessibilité de l'adresse de livraison.\n   - Délais de livraison: 2-6 semaines (pour les groupages, cela peut prendre un peu plus de temps).";
        this.operation_data.mail_bottom_payment =
          "Paiement:\n   - Paiement à la commande.";
      } else if (this.bottomMailTemplateId.value === 3) {
        // RO
        this.operation_data.mail_bottom =
          "   - Stalpi de salcam.\n   - Diametru masurat la mijloc.\n   - Descărcarea camionului (40 tone) să fie efectuată de către client. De asemenea, el trebuie să verifice accesibilitatea la adresa de livrare. \n   - Timp de livrare: 2-6 saptamani (pentru grupaj, poate dura mai mult).";
        this.operation_data.mail_bottom_payment =
          "Plată:\n   - Plata la comanda.";
      } else if (this.bottomMailTemplateId.value === 4) {
        // DE
        this.operation_data.mail_bottom =
          "   - Robinienholz.\n   - Durchmesser und Umfang in der Mitte gemessen.\n   - Der Kunde kümmert sich um das Entladen des LKW (40-Tonnen-Sattelauflieger) und die Überprüfung der Zugänglichkeit der Lieferadresse.\n   - Lieferzeit: 2-6 Wochen ab Zahlungseingang (Bei Mengen unter einem vollen LKW kann es etwas länger dauern).";
        this.operation_data.mail_bottom_payment =
          "Zahlung:\n   - Zahlung bei der Bestellung.";
      } else if (this.bottomMailTemplateId.value === 5) {
        // ES
        this.operation_data.mail_bottom =
          "   - Esencia de madera: Robinia Pseudoacacia.\n   - Diámetro medido en el medio.\n   - El Cliente se encarga de descargar el camión (semirremolque de 40 toneladas) y verificar la accesibilidad de la dirección de entrega.\n   - El tiempo de entrega: 2-6 semanas (para el transporte en grupaje, puede tardar un poco más).";
        this.operation_data.mail_bottom_payment =
          "Pago:\n   - El pago debe hacerse al realizar el pedido.";
      } else if (this.bottomMailTemplateId.value === 6) {
        // NL
        this.operation_data.mail_bottom =
          "   - Houtsoort: Robinia Pseudoacacia.\n   - Diameter gemeten in het midden.\n   - De klant zorgt voor het lossen van de vrachtwagen (vrachtwagen van 40 ton) en het verifiëren van de bereikbaarheid van het afleveradres.\n   - Levertermijn: 2-6 weken (voor bestellingen kleiner dan een volle vrachtwagen kan het wat langer duren).";
        this.operation_data.mail_bottom_payment =
          "Betaling:\n   - Betaling bij de bestelling.";
      }
    },
    // Les deux listes d'options d'abord (Promise.all), la selection ENSUITE.
    // Avant, la resolution de la selection etait lancee depuis chacun des deux
    // .then() : quatre requetes concurrentes, et la premiere tournait contre une
    // liste d'options encore vide. Deux vagues, un seul ordre possible.
    //
    // `personChanged` = le contact vient d'etre change dans le v-select. On ne
    // relit alors PAS l'adresse liee a l'operation : elle appartient encore a
    // l'ANCIEN contact, et la reinjecter dans les options du nouveau est
    // exactement le « l'adresse a saute » signale. On propose l'adresse par
    // defaut du nouveau contact, visible dans le v-select avant tout Save.
    async getBillingAndDeliveryAddressList(personChanged = false) {
      this.getAllocatedBroker();
      this.billingAddressId = null;
      this.deliveryAddressId = null;
      this.billingAddressUnlinked = false;
      this.deliveryAddressUnlinked = false;
      this._beginAddressLoading();
      // Sans contact, il n'y a pas d'adresse a charger : ne pas dereferencer
      // this.personId.value (TypeError silencieux qui laissait le drapeau de
      // chargement a vrai, donc le bouton Save grise pour toujours).
      if (!this.personId || this.personId.value === null || this.personId.value === undefined) {
        this.data_option_billing_address = [];
        this.data_option_delivery_address = [];
        this._endAddressLoading();
        return;
      }
      try {
        const [billing, delivery] = await Promise.all([
          axios.get("/person/getaddressbilling/" + this.personId.value).catch(() => ({ data: [] })),
          axios.get("/person/getaddressdelivery/" + this.personId.value).catch(() => ({ data: [] })),
        ]);
        this.data_option_billing_address = [...((billing && billing.data) || [])];
        // Adresse par defaut en tete.
        this.data_option_delivery_address = [...((delivery && delivery.data) || [])].sort((a, b) => {
          if (a.isdefault === true && b.isdefault !== true) return -1;
          if (a.isdefault !== true && b.isdefault === true) return 1;
          return 0;
        });
        await this.getSelectedBillingAndDeliveryAddressList(personChanged);
      } finally {
        this._endAddressLoading();
      }
    },
    async getAllocatedBroker() {
      {
        if (this.personId) {
          axios
            .get("/people/data/" + this.personId.value)
            .then((response) => {
              this.operation_data.idbroker = response.data.idbroker;
              this.databroker = [...response.data];

              // Récupérer les informations du broker
              if (response.data.idbroker) {
                axios.get("/people/data/" + response.data.idbroker)
                  .then((brokerResponse) => {
                    this.data_option_broker_name = [
                      {
                        value: brokerResponse.data.id,
                        label: brokerResponse.data.iscompany
                          ? brokerResponse.data.company_name
                          : brokerResponse.data.firstname + ' ' + brokerResponse.data.lastname
                      }
                    ];
                    this.brokerId = this.data_option_broker_name[0];
                  });
              }
            });
        }
      }
    },
    async getPersonLanguageAndVATNumber() {
      {
        await axios
          .get("/people/data/" + this.personId.value)
          .then((response) => {
            this.selectedVatNumber = response.data.vat_number;
            this.selectedLanguage = response.data.language.id;
            // Le gabarit de bas de mail n'etait rempli que depuis le .catch() de
            // la recuperation d'adresse. Depuis que l'adresse se resout, cette
            // branche ne part plus : mail_bottom restait NULL et tout le bas du
            // PDF (details, paiement, CGV, signature) disparaissait. On l'ancre
            // ici, ou la langue dont il depend vient justement d'etre lue.
            this.getBottomMailTemplate();
          });
      }
    },
    // `personChanged` : voir getBillingAndDeliveryAddressList. Les deux
    // chaines sont RENVOYEES, donc reellement attendues par l'appelant —
    // avant, elles partaient en fire-and-forget et le drapeau de chargement
    // retombait a faux alors que les adresses n'etaient pas encore resolues.
    async getSelectedBillingAndDeliveryAddressList(personChanged = false) {
      const billingChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressbilling/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.billingAddressId = this.pickAddressOption(this.data_option_billing_address, selectedAddress);
            this.billingAddressUnlinked = false;
            // Vérifier si le produit est du "lemn de foc" et ajuster la TVA
            this.updateTvaForFirewood();
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.billingAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.billingAddressId) {
              this.billingAddressId = this.proposeAddressOption(this.data_option_billing_address);
              // Ne jamais écraser une TVA déjà enregistrée sur le devis : ce
              // repli ne sert qu'à proposer un taux pour un document neuf.
              if (!this.storedTvaLocked) {
                if (
                  this._firstAddressLabel(this.data_option_billing_address).includes("Romania")
                ) {
                  this.dataTva = "21";
                  // Vérifier si le produit est du "lemn de foc" (bois de chauffage)
                  this.updateTvaForFirewood();
                } else {
                  if (this.operation_data.people[0].subject_vat) {
                    this.dataTva = "0";
                  } else {
                    if (
                      this._firstAddressLabel(this.data_option_billing_address).includes(
                        "Belgium"
                      )
                    ) {
                      this.dataTva = "21";
                    } else {
                      // Repli hors RO/BE pour un document neuf. 19 % etait l'ancien
                      // taux roumain, mort depuis le passage a 21 % (reduit 11 %).
                      this.dataTva = "21";
                    }
                  }
                }
              }
            }
            // getBottomMailTemplate() vivait ici : il ne partait donc que quand
            // l'adresse echouait. Il est appele depuis
            // getPersonLanguageAndVATNumber(), quel que soit le sort de l'adresse.
          })

      const deliveryChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressdelivery/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.deliveryAddressId = this.pickAddressOption(this.data_option_delivery_address, selectedAddress);
            this.deliveryAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.deliveryAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.deliveryAddressId)
              this.deliveryAddressId = this.proposeAddressOption(this.data_option_delivery_address);
          })

      return Promise.all([billingChain, deliveryChain]);
    },
    async getQuotationStatus() {
      axios.get("/quotationstatus/data").then((response) => {
        this.data_option_quotation_status = [...response.data];
        if (this.operation_data.quotationstatus) {
          const ItemIndex = this.data_option_quotation_status.findIndex(
            (p) => p.value === this.operation_data.quotationstatus.id
          );
          this.statusId = this.data_option_quotation_status.splice(
            ItemIndex,
            1
          );
        } else {
          this.statusId = this.data_option_quotation_status.splice(2, 1);
        }
      });
    },
    async getPeople() {
      axios.get("/people_name/data").then((response) => {
        this.data_option_people_name = [...response.data];
        const ItemIndex = this.data_option_people_name.findIndex(
          (p) => p.value === this.operation_data.people[0].id
        );
        if (ItemIndex !== -1) {
          this.personId = this.data_option_people_name.splice(ItemIndex, 1)[0];
        } else {
          // Le client du devis n'est pas dans /people_name/data (liste des
          // contacts ACTIFS) : ne pas splice(-1), qui selectionnait le DERNIER
          // contact de la liste — donc les adresses d'un autre client dans les
          // deux listes, et ce mauvais client renvoye au Save (idperson). Meme
          // garde que l'ecran broker : on reconstruit personId depuis le devis.
          const p0 = this.operation_data.people[0];
          const label = p0.iscompany
            ? (p0.company_name || "")
            : ((p0.firstname || "") + " " + (p0.lastname || "")).trim();
          this.personId = { value: p0.id, label: label };
          this.data_option_people_name.unshift(this.personId);
        }
        this.getBillingAndDeliveryAddressList();
        this.getReferencePrice();
        this.getPersonLanguageAndVATNumber();
      });
    },
    async getReferencePrice() {
      if (this.personId) {
        axios
          .get("/people/data/" + this.personId.value)
          .then((response) => {
            localStorage.setItem(
              "clientReferencePrice",
              response.data.ref_price
            );
            localStorage.setItem(
              "clientType",
              response.data.client_type
            );
          });
      }
    },
    confirmTransformToSale() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "Confirm Sale",
        text: `You are about to transform  ${namealert} to a Sale`,
        accept: this.transformToSale,
        acceptText: "Transform",
      });
    },
    transformToSale() {
      /// ICI
      const obj = {
        id: this.operation_data.id,
        idperson: this.personId.value,
        idquotationstatus: null,
        idsalestatus: 1,
        idoperationcategory: 2,
        tva: this.dataTva,
        date: moment(this.operation_data.date),
      };
      if (this.operation_data.id) {
        this.$store
          .dispatch("operationList/updateOperation", obj)
          .catch((err) => {
            console.error(err);
          });
        this.$router.push({ path: "/sale/" + this.operation_data.id });
      }
      this.showTransformSuccess();
    },
    showTransformSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Transformed",
        text: "The selected Quotation was successfully transformed into a Sale",
      });
    },
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable",
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable",
      });
    },
    enableRecord() {
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/quotation/" + this.operation_data.id, query: { fromEdit: true } });
      this.showEnableSuccess();
    },
    // Les .catch vides masquaient tout echec de /operation/enable|disable :
    // l'ecran affichait « successfully deleted » et l'operation etait toujours la.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled",
      });
    },
    deleteRecord() {
      axios
        .post("/operation/disable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/quotation/" + this.operation_data.id, query: { fromEdit: true } });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    editData(data) {
      /* this.$store.dispatch('operationList/updateOperation', obj).catch(err => { console.error(err) })*/
      data.idperson = this.operation_data.id;
      localStorage.setItem("clientId", this.personId.value);
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    addNewData() {
      if (this.operation_data.id) {
        localStorage.setItem("clientId", this.personId.value);
        var idoperation = this.operation_data.id;
        this.sidebarData = { idoperation };
        this.toggleDataSidebar(true);
      }
    },
    save_changes() {
      if (this.addressesLoading) {
        this.$vs.notify({
          color: "warning",
          title: "Please wait",
          text: "Addresses are still loading...",
        });
        return;
      }
      // Un champ TVA vide n'est pas une exonération : sans ce garde-fou le
      // backend écrivait 0% sur toutes les lignes du devis.
      if (
        this.dataTva === null ||
        this.dataTva === undefined ||
        String(this.dataTva).trim() === "" ||
        !Number.isFinite(Number(this.dataTva))
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Missing VAT",
          text: "Enter a VAT percentage (0, 11, 21…) before saving.",
        });
        return;
      }
      let isfsc = null
      if (this.operation_data.fsc) isfsc = 'TRUE'
      else isfsc = 'FALSE'

      let callclient = null
      if (this.operation_data.callclient) callclient = 'TRUE'
      else callclient = 'FALSE'
      /* eslint-disable */
      let sumal_mode = null
      if (this.sumaltip) sumal_mode = this.sumaltip.value
      let transporttiplt = null
      if (this.transporttip) transporttiplt = this.transporttip.value

      let remorcatiplt = null
      if (this.remorcatip) remorcatiplt = this.remorcatip.value


      let _idbilling = null;
      if (this.billingAddressId) {
        _idbilling = this.billingAddressId.value;
      }
      let _iddelivery = null;
      if (this.deliveryAddressId) {
        _iddelivery = this.deliveryAddressId.value;
      }

      let _incoterms = null;
      if (this.IncotermId) _incoterms = this.IncotermId.value;

      let incoterms_dest = null;
      if (this.dataIncotermsDest) incoterms_dest = this.dataIncotermsDest;

      let quotation_tag = null
      if (this.quotation_tag) quotation_tag = this.quotation_tag.value

      const selectedStatus = Array.isArray(this.statusId) ? this.statusId[0] : this.statusId;
      const selectedStatusValue = selectedStatus ? selectedStatus.value : null;
      const selectedStatusLabel = selectedStatus && selectedStatus.label
        ? selectedStatus.label.toLowerCase()
        : "";
      const isApprovedStatus = selectedStatusValue === 2 || selectedStatusLabel === "approved";
      const isZeroVat = Number(this.dataTva) === 0;
      const vatNumber = (
        this.selectedVatNumber ||
        (this.operation_data &&
          this.operation_data.people &&
          this.operation_data.people[0] &&
          this.operation_data.people[0].vat_number) ||
        ""
      ).toString().trim();

      if (isApprovedStatus && isZeroVat && !vatNumber) {
        this.$vs.notify({
          color: "danger",
          title: "Approval blocked",
          text: "Approval is not possible because VAT is set to 0% and the customer VAT number is missing. Please add a VAT number or use a non-zero VAT rate before approving this quotation.",
        });
        return;
      }

      const obj = {
        id: this.operation_data.id,
        idperson: this.personId.value,
        isquotationparent: this.operation_data.isquotationparent,
        idquotationstatus: selectedStatusValue,
        date: moment(this.operation_data.date),
        date_delivery_desired: moment(
          this.operation_data.date_delivery_desired
        ),
        tva: this.dataTva,
        mail_top: this.operation_data.mail_top,
        mail_bottom: this.operation_data.mail_bottom,
        mail_bottom_payment: this.operation_data.mail_bottom_payment,
        iddelivery: _iddelivery,
        idbilling: _idbilling,
        incoterms: _incoterms,
        incoterms_dest: incoterms_dest,
        transport_tip: transporttiplt,
        transport_remorca_type: remorcatiplt,
        //acompte_amount: this.dataAdvanceEur,
        acompte_amount: this.dataAdvancePct,
        fsc:isfsc,
        ref_client: this.operation_data.ref_client,
        delivery_lead_time: this.operation_data.delivery_lead_time,
        callclient:callclient,
        sumal_mode:sumal_mode,
        quotation_tag:quotation_tag,
        idbroker:this.operation_data.idbroker,
        who:localStorage.getItem("login-username")
      };
      if (this.operation_data.id) {
        this.$store
          .dispatch("operationList/updateOperation", obj)
          .catch((err) => {
            console.error(err);
          });
        this.$router.push({ path: "/quotation/" + this.operation_data.id, query: { fromEdit: true } });

        this.$vs.notify({
          color: "success",
          title: "Operation Updated!",
          text: "The operation was successfully updated",
        });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Deleted",
        text: "The Product was successfully deleted",
      });
    },
    deleteProductOne() {
      const obj = {
        idproduct: this.producttodelete,
        idoperation: this.operation_data.id,
        who: localStorage.getItem("login-username"),
      };
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule("operationList", moduleOperationList);
        moduleOperationList.isRegistered = true;
      }
      this.$store.dispatch("operationList/removeItem", obj).catch((err) => {
        console.error(err);
      });
      //refresh view after delete
      this.$store
        .dispatch("operationList/fetchm3difference", this.$route.params.userId)
        .then((res) => {
          //this.m3difference = res;
          //console.log(this.$store.state.operationList.m3difference)
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
      this.showDeleteAddressSuccess();
    },
    deleteProduct(id, name) {
      this.producttodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the product ${name}`,
        accept: this.deleteProductOne,
        acceptText: "Delete Product",
      });
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then((res) => {
            this.operation_data = res.data;
            this.getPeople();
            this.getQuotationStatus();
            // Le taux enregistré fait foi : s'il existe on le garde tel quel et
            // on verrouille tout recalcul automatique. Sinon (devis neuf ou taux
            // jamais renseigné) la règle pays/bois de feu peut proposer.
            const storedTva = this.readStoredTva();
            if (storedTva !== null) {
              this.dataTva = storedTva;
              this.storedTvaLocked = true;
            } else if (this.operation_data.products.length > 0) {
              this.updateTvaForFirewood();
            }
            this.applyStoredIncoterm();
            if (this.operation_data.acompte_amount) {
              this.dataAdvancePct = this.operation_data.acompte_amount;
              this.calculateAdvanceFromEurInput();
            }
            const ItemIndex = this.select_trailer_type.findIndex(
              (p) => p.value === res.data.transport_remorca_type
            );
            this.remorcatip = this.select_trailer_type[ItemIndex];

            const ItemIndexTruck = this.select_transport_type.findIndex(
              (p) => p.value === res.data.transport_tip
            );
            this.transporttip = this.select_transport_type[ItemIndexTruck];

            const ItemSumalMode = this.select_sumal_override.findIndex(
              (p) => p.value === res.data.sumal_mode
            );
            this.sumaltip = this.select_sumal_override[ItemSumalMode];

            const ItemQuotationTag = this.select_quotation_tag.findIndex(
              (p) => p.value === res.data.quotation_tag
            );
            this.quotation_tag = this.select_quotation_tag[ItemQuotationTag]

            // Initialiser le broker si disponible
            if (res.data.Broker) {
              this.data_option_broker_name = [
                {
                  value: res.data.Broker.id,
                  label: res.data.Broker.iscompany
                    ? res.data.Broker.company_name
                    : res.data.Broker.firstname + ' ' + res.data.Broker.lastname
                }
              ];
              this.brokerId = this.data_option_broker_name[0];
            }

          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.operation_data = {};
      }
    },
    fetch_product_data(userId) {
      if (userId) {
        this.$store.dispatch("operationList/fetchOperationProducts", userId);
        // this.$store.state.dataListProduct.products
        /*this.$store.dispatch('operationList/fetchOperationProducts', userId)
          .then(res => {
            this.product_data = res.data
            console.log(res)
            console.log(this.product_data)
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.user_not_found = true
              return
            }
            console.error(err)
          })*/
      } else {
        this.product_data = {};
      }
    },
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
    this.fetch_product_data(this.$route.params.userId);
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

